<script lang="ts">
    import {availableProjectLeaders} from "$lib/calls/customer";
    import SortableTable from "$lib/components/SortableTable.svelte";
    import Checkbox from "$lib/components/ui/Checkbox.svelte";
    import RemoveButton from "$lib/components/ui/RemoveButton.svelte";
    import {createAssociate} from "$lib/calls/associate";
    import {Button} from "flowbite-svelte";

    export let project;

    export let header = [
        {
            label: 'Name',
            property: 'name'
        },
        {
            label: 'Email',
            property: 'email'
        },
        {
            label: 'Zeichnungsberechtigt',
            property: 'isSignatory',
            component: Checkbox,
            props: {},
            class: 'w-1/4'
        },
        {
            label: 'Entfernen',
            property: 'index',
            component: RemoveButton,
            props: {
                onClick: index => {
                    project.associates = project.associates.filter((x,ind) => ind !== index)
                },
                classes: 'text-center'
            },
            class: 'w-8'
        }
    ];

    let unknownAssociate = {
        name: '',
        email: '',
    }
    let showPartials = true;
    const addAssociate = member => {
        project.associates = [...project.associates,{...member, isSignatory: false}]
    }
    const externalAssociate = async external => {
        const parts = external.name.split(' ');
        let newAssociate = {
            firstName:parts.map((x,i) => i === parts.length-1 ? '': x).join(' ').slice(0, -1),
            lastName: parts[parts.length-1],
            name: external.name,
            email: external.email,
            isSignatory: false,
            id: undefined
        }
        const {id} = await createAssociate(newAssociate)
        newAssociate.id = id
        addAssociate(newAssociate)
        unknownAssociate.name = '';
        unknownAssociate.email = ''
    }

</script>
{#await availableProjectLeaders()}
    Loading...
{:then team}
    <h3 class="text-2xl  leading-7 text-neutral-600 mb-3 mt-4">Weitere Ansprechpartner</h3>
    <SortableTable emptyText="Keine zusätzlichen Ansprechpartner ausgewählt" bind:data={project.associates} bind:header />
    <h3 class="mt-5 text-md font-medium text-neutral-500">
        Teammitglieder hinzufügen
    </h3>
    <ul role="list" class="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
        {#each team.filter(x => x.userId !== project.responsibleAssociateId &&  (typeof project.associates == 'undefined' || !project.associates.find(y => y.id === x.id))).filter((x,i) => showPartials ? i < 6 : true) as member}
        <li>
            <button
                    on:click={() => addAssociate(member)}
                    type="button"
                    class="text-neutral-600 group flex w-full items-center justify-between space-x-3 rounded-full border border-neutral-300 p-2 text-left shadow-sm hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-coolGray-500 focus:ring-offset-2">
                <span class="flex min-w-0 flex-1 items-center space-x-3">
                    <span class="block flex-shrink-0">
                        <div class="h-10 w-10 rounded-full bg-coolGray-400 flex justify-center items-center font-bold text-white">
                            {member.firstName[0]}{member.lastName[0]}
                        </div>
                    </span>
                    <span class="block min-w-0 flex-1">
                        <span class="block truncate text-sm font-medium text-neutral-900">
                            {member.name}
                        </span>
                        <span class="block truncate text-sm font-medium text-neutral-500">
                            {member.email}
                        </span>
                    </span>
                </span>
                <span class="inline-flex h-10 w-17 flex-shrink-0 items-center justify-center pr-6">
                                                                <!-- Heroicon name: mini/plus -->
                    <svg class="h-5 w-5 text-coolGray-400 group-hover:text-neutral-500"
                         xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 20 20" fill="currentColor"
                         aria-hidden="true"><path
                            d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"/></svg>
                </span>
            </button>
        </li>
        {:else}
        <li>
            <p class="py-5 text-red-400">Keine Teammitgliedervorschläge übrig</p>
        </li>

        {/each}

    </ul>
    {#if showPartials && team.length > 6}
        <div class="text-center mt-7 mb-3">
            <button class="text-md font-medium text-neutral-500" on:click={() => showPartials = !showPartials}>mehr laden</button>
        </div>
    <div class="my-5  border-b">

    </div>
    {/if}

    <h3 class="my-5 text-md font-medium text-neutral-500">
        Externe Ansprechpartner hinzufügen
    </h3>
    <form
            class="group flex w-full items-center justify-between space-x-3 rounded-full border border-neutral-300 p-2 text-left shadow-sm hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-coolGray-500 focus:ring-offset-2"
            on:submit|preventDefault|capture={() => externalAssociate(unknownAssociate)}>

        <div class="flex min-w-0 flex-1 items-center space-x-3">
            <div class="min-w-0 flex-1 flex gap-3">
                <input class="border-0 rounded-md h-6 flex-1" placeholder="Name" type="text" bind:value={unknownAssociate.name} required>
                <input class="border-0 rounded-md h-6  flex-1" placeholder="Email" type="email" bind:value={unknownAssociate.email} required>
            </div>
            <button type="submit" class="inline-flex h-10 17 flex-shrink-0 items-center justify-center text-neutral-600 pr-6">
                <!-- Heroicon name: mini/plus -->
                <svg class="h-5 w-5 text-coolGray-400 group-hover:text-neutral-500"
                     xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 20 20" fill="currentColor"
                     aria-hidden="true"><path
                        d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"/></svg>
            </button>
        </div>
    </form>
{/await}